export enum ManagingCompanies {
    ALL_COMPANIES = 'ALL_COMPANIES', // (-1)
    REUT = 'REUT', // (2),
    MINHL = 'MINHL', // (4),
    ROM = 'ROM', // (5),
    ARAM = 'ARAM', // (8),
    ELAL = 'ELAL', // (15),
    HISHTALMUT_HANDESAIM = 'HISHTALMUT_HANDESAIM', // (520028556),
    GEMEL_HANDESAIM = 'GEMEL_HANDESAIM', // (520042607),
    GLOBAL_NET = 'GLOBALNETGEMEL', // (516463635),
    GAL_GEMEL = 'GAL_GEMEL', // (512711409),
    MISHPATANIM = 'MISHPATANIM', // (7),
    AYALON = 'AYALON', // (22),
    AMI = 'AMI-GML', // (520042581),
    AMI_OVDEI_MEDINA = 'OVDEIMEDINA', // (520042581),
    HUJI_GEMEL = 'HUJI-GEMEL', // (520042581),
    INFINITY_GEMEL = 'INFINITY_GEMEL', // (30),
    INFINITY = 'INFINITY', // (513621110),
    GILAD = 'GILAD', // (520023094)
    TAASIA_AVIRIT = 'GEMELIAI',
    HISHTALMUT_OTZEM = 'HISHTALMUT-OTZEM',
    GEMEL_OTZEM = 'GEMEL-OTZEM',
}